export const getParsedLabels = (labels, othersText) => {
  const parsedLabels = labels.map((label) =>
    label.isOthers ? { ...label, name: othersText } : label
  );

  return parsedLabels;
};

export const getBaseUrl = () => `/developments?commercialization=true`;

export const handleClickBar = (typeId) => {
  let url = getBaseUrl();
  const ids = Array.isArray(typeId) ? typeId : [typeId];
  url += `&type=${ids}`;
  window.open(url, '_blank');
};

export const handleTooltip = (context, labels) => {
  const labelIndex = context.dataIndex;
  const label = labels[labelIndex];

  if (!label.isOthers) {
    return `${label.name}: ${label.count}`;
  }

  if (label.isOthers && label.othersDetail) {
    const maxVisible = 12;
    const visible = label.othersDetail.slice(0, maxVisible);
    const remaining = label.othersDetail.length - maxVisible;

    const detailLines = visible.map((item) => `${item.name}: ${item.count}`);

    if (remaining > 0) {
      detailLines.push(`${remaining} more...`);
    }

    return detailLines;
  }

  return `${label.name}: ${label.count}`;
};
